<template>
    <div id="overlay" >
        
        <div id="main" style="height:90%;width:95%;max-width: 1300px;background-color: white;">
        <div id="vy_left_nav"  v-bind:class="list_class" style="padding:10px;">
          <!--左サイドバー-->
          <component  v-if="displayLeft"
                        v-bind:is="contentLeft"
                        v-bind:param="search_param"
                        v-on:call="call"/>
        </div>
        <div id="vy_main" v-bind:class="main_class">
          <main>

            <component  v-if="displayStatus"
                       ref="ref_content"
                       v-bind:is="content"
                       v-bind:param="param"
                       v-on:call="call">{{ title }}</component>
          </main>
        </div>
        <p id="button_area">
                <button class="btn btn-primary" style="padding-top: 5px;margin-top: 10px;" v-on:click="Close_window">キャンセル</button>
                
        </p>
      </div>
   
    </div>
  </template>
  

<script setup>

// ローカルJavascriptファイルの指定
import { GlobalData } from '../../js/userdata_shakyo.js'
//import { useRouter, useRoute } from 'vue-router'
import { ref, nextTick  } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import axios from 'axios'

const URL = GlobalData.$API_URL
//const router = useRouter();
const route = useRoute();

/* eslint-disable */
import ShakyoFacilityList from '../Facility/ShakyoFacilityList.vue'
import ShakyoFacilityLeftBar from '../Facility/ShakyoFacilityLeftBar.vue'

const props = defineProps(["param"])

let Facility_id = props.param.facility_id

let displayStatus = ref(true) //子コンポーネントを再レンダリングさせるためのフラグ
let displayLeft = ref(true) //左バーコンポーネントを表示・非表示させるフラグ

/* 親コンポーネントに関わる関数 */
const emit = defineEmits(['call'])

const store = useStore()

/* 表示する子コンポーネント関係の情報 */
const content = ref('')// 表示する子コンポーネントの情報
content.value = "" // 表示する子コンポーネント
let param = {}//子コンポーネントに送る値の連想配列。中身は子コンポーネントに合わせて常に入れ替わる

const contentLeft = ref('')// 表示する子コンポーネントの情報（左バー）
contentLeft.value = null // 表示する子コンポーネント
let search_param = {}

store.state.facility = search_param

let title = "体験プログラム参加代行"

  // 受入先検索結果を挿入する配列
let results = []     //全件
// 受入先一覧関係
let page = 1 // 表示中のページ
let page_read_count = 10 // 表示件数
let facility_list_scrollpos = 0 // スクロール位置

// ソート項目
let order = "facility.facility_id"  //並び替えの基準となるデータ項目
let mode = "ASC" //昇順（ASC）or降順（DESC）

// 検索する
let search_error = 0
let Search = function() {  

    // 受入先情報取得用の取得スタート位置と取得数の設定
    if(isFinite(search_param.page) && isFinite(search_param.read_count)){
        search_param.read_start = (search_param.page - 1) *  search_param.read_count
    }

    axios.post(URL + "facility_get",search_param,GlobalData.$ID_Token)  //ヘッダーを追加（IDトークンを送信）
    .then(response => {

        if(response.data.status == "1"){
            alert(response.data.message)
            return
        }

        results = response.data.all_facility_info;

        // 子コンポーネントに送る値を格納
        // ShakyoUserList(検索結果)へ送る値
        param = {'results':results,"page":page,"page_read_count":page_read_count,"all_count":response.data.all_count,"from":true }
        
        // 検索結果コンポーネント（list）を表示
        content.value = ShakyoFacilityList
        contentLeft.value = ShakyoFacilityLeftBar

        // スクロール位置の復活
        Page_scroll_list(facility_list_scrollpos);

        // 子コンポーネントを再レンダリング
        Rendering_child()

    })
    .catch(error => {
        if(search_error == 6){
            alert(error + GlobalData.$axios_error)
        }else{
            search_error++
            setTimeout(function(){Search()},"1000")
        }
    })
}

// 指定した高さになるまで待つ
const waitForScrollableHeight = (el, targetTop, maxWait = 3000) => {
  return new Promise((resolve) => {
    const start = performance.now()

    const check = () => {
      const scrollEl = el || document.documentElement
      const currentMaxScroll = scrollEl.scrollHeight - scrollEl.clientHeight

      // 目的位置までスクロールできる高さが確保できたら完了
      if (currentMaxScroll >= targetTop) {
        resolve(true)
        return
      }

      // タイムアウト
      if (performance.now() - start > maxWait) {
        resolve(false)
        return
      }

      requestAnimationFrame(check)
    }

    check()
  })
}

// ページの一番上にスクロールする：height＝位置（上から何pxか）
const Page_scroll_list = async (height) => {
  if (!height) return

  await nextTick()

  const isSP = window.matchMedia("(max-width: 960px)").matches

  if (isSP) {
    await waitForScrollableHeight(document.documentElement, height)
    window.scrollTo({
      top: height,
      left: 0,
      behavior: "auto"
    })
  } else {
    const el = document.querySelector("#vy_main")
    if (!el) return

    await waitForScrollableHeight(el, height)
    el.scrollTo({
      top: height,
      behavior: "auto"
    })
  }
}

// 子コンポーネントを再レンダリングする
let Rendering_child = function(){
    // v-if="displayStatus"で表示・非表示を繰り返し、再レンダリングする
    // ただtrueに戻すだけでは表示は切り替わらないので、nextTickで囲んでから戻すこと
    
    displayStatus.value = false
    nextTick(() => {
        displayStatus.value = true
    })
}

const call = function(proc) {

    button_area.value = true

    switch(proc.cmd) {
        case "search":
            // 子コンポーネント（ShakyoUserLeftBar）側から送られてきた条件を代入して再検索
            // 検索条件を連想配列に保存
            search_param = {
                choson_code: route.params.shakyo,
                facility_name: proc.facility_name,
                facility_jusyo: proc.facility_jusyo,
                facility_tel: proc.facility_tel,
                facility_fax: proc.facility_fax,
                facility_email: proc.facility_email,
                facility_tantou: proc.facility_tantou,
                facility_comment: proc.keyword,
                facility_bikou: proc.keyword,
                page: page,
                read_count: page_read_count,
                order: order,
                mode: mode
            }

            // 連想配列をstoreに保存
            store.state.facility = search_param

            // 検索開始
            setTimeout(function(){ Search()}, "1000");
            
            // URLは検索に戻す（詳細から検索を始めた場合の対処）
            // router.push('/'+GlobalData.shakyo+'/Kanri/Facility/list')
            break
        case 'page_change':
        case 'count_change':
             // 子コンポーネント側（ShakyoUserList）からの命令で検索件数を保管する
            page = proc.page0;
            page_read_count = proc.page_read_count0;
            search_param.page = page
            search_param.read_count = page_read_count

            facility_list_scrollpos = 0

            Search()

            break
        case "scroll_position":
            // 受入先一覧のスクロール位置を保存する
            facility_list_scrollpos = document.querySelector("#vy_main").scrollTop
            break
        case "selected":
        
            emit('call',{cmd:'facility_select',facility:proc.facility})
//            emit('call',{cmd:'facility_select',facility_id:proc.facility_id,facility_name:proc.facility_name,facility:proc.facility})
            break
        default:

            break
    }
}

// このウィンドウを閉じる
let Close_window = function(){
  if(window.confirm("このウィンドウを閉じますか？")){
      emit('call',{cmd:'facility_close'});
  }
}

  //－－－－－－－－  初期処理 －－－－－－－－ 
//    Category_read()

if(Object.keys(store.state.facility).length){
    search_param = store.state.facility
}else{
    // 検索条件を連想配列に保存
    search_param = {
        choson_code: route.params.shakyo,
        facility_name: "",
        facility_jusyo: "",
        facility_tel: "",
        facility_fax: "",
        facility_email: "",
        facility_tantou: "",
        facility_comment: "",
        facility_bikou: "",
        page: page,
        read_count: page_read_count,
        order: order,
        mode: mode
    }
    // 連想配列をstoreに保存
    store.state.facility = search_param
}
Search()

</script>



<style scoped>
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}

#content_modal{
  /* 要素を重ねた時の順番 */
  z-index:2;
  height:auto;
  text-align: center;
  padding: 1em;
  background:#fff;
  white-space: pre-line;
}
#content_modal button{
    width:120px;
    height: 30px;
    padding: 0;
}

#vy_main{
    height: 90%;
}
.main_list{
    width: 80%;
    float: right;
}



#vy_left_nav{
    float: left;
    height: 100%;
    padding-bottom: 10px;
}

.left_list{ 
    width: 20%;
}

.left_other{
    width: 0%;
    display: none;
}


</style>